module.exports = __webpack_public_path__ + "static/media/bg_without_flag.b58f71de.jpg";